
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.064 10.479l3.022-.771 1.263 3.916-4.285-3.145zm6.956-5.063H8.7L7.063.375 5.428 5.416H.108l4.306 3.125-1.636 5.042 4.306-3.125 2.65-1.917 4.286-3.125z","fill":"#fff"}})])
          )
        }
      }
    